export const selectAssistantsLoading = (state) =>
  state.delegation.assistantsLoading;
export const selectAssistedForLoading = (state) =>
  state.delegation.assistedForLoading;

export const selectAssistedFor = (state) => state.delegation.assistedFor;

export const selectAssistants = (state) => state.delegation.assistants;
